import { combineReducers } from 'redux';
import INTL from './types'

const initialLanguages = ['en', 'th']
const initialShowButton = [true, false]

const currentLang = (state = initialLanguages[0], action) => {
  const { language } = action
  switch (action.type) {
    case INTL.SWITCH_LANGUAGE:
      return language
    default:
      return state
  }
}

const availableLanguages = (state = initialLanguages, action) => {
  switch (action.type) {
    default:
      return state
  }
}

const showButton = (state = initialShowButton[0], action) => {
  switch (action.type) {
    case INTL.SWITCH_BUTTON:
      return action.show
    default:
      return state
  }
}

export default combineReducers({
  currentLang,
  availableLanguages,
  showButton,
})


// WEBPACK FOOTER //
// ./src/store/intl/reducer.js